export const IS_SCHEDULE = {
  AG: true,
  AGRE: true,
};
